import React from "react";
import { Crown, Sparkles, LayoutGrid } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BidCard } from "@/components/BidCard";
import { LeadingFor } from "@/components/LeadingFor";

export function LeaderboardBoard({ entries, keywordName, onClaim, currency = "$", claimLabel, onNudge, showPhone = false }) {
  if (!entries || entries.length === 0) {
    return (
      <div data-testid="empty-board" className="glass rounded-3xl border-2 border-dashed border-white/20 p-10 sm:p-16 text-center">
        <div className="w-20 h-20 mx-auto rounded-2xl bg-gradient-to-br from-blue-500/20 to-violet-500/20 flex items-center justify-center mb-6">
          <Crown className="w-10 h-10 text-blue-400" />
        </div>
        <div className="text-xs font-bold uppercase tracking-[0.25em] text-white/40 mb-3">Unclaimed board</div>
        <h3 className="font-display font-black text-2xl sm:text-4xl tracking-tighter mb-3">
          This podium is empty.
        </h3>
        <p className="text-white/60 max-w-md mx-auto mb-8 leading-relaxed">
          Nobody owns <span className="text-white font-semibold">"{keywordName}"</span> yet. Be the first to plant your flag and every searcher sees you first.
        </p>
        <Button
          data-testid="claim-first-spot-btn"
          onClick={onClaim}
          className="cta-pulse rounded-full h-14 px-8 text-base bg-gradient-to-r from-blue-600 to-indigo-600 hover:opacity-90 active:scale-95 transition-all font-bold"
        >
          <Sparkles className="w-5 h-5 mr-2" />
          {claimLabel || "Claim the top spot for $5.00"}
        </Button>
      </div>
    );
  }

  const podium = entries.filter((e) => e.rank <= 3);
  const directory = entries.filter((e) => e.rank > 3);
  const leader = podium[0];

  return (
    <div className="space-y-4" data-testid="leaderboard">
      {podium.map((e) => (
        <div key={e.user_id}>
          <BidCard entry={e} currency={currency} onNudge={onNudge} showPhone={showPhone} />
          {e.rank === 1 && leader?.held_since && Number(leader.effective_bid) > 0 && (
            <div className="mt-1.5 ml-11 sm:ml-16"><LeadingFor since={leader.held_since} className="text-xs" /></div>
          )}
        </div>
      ))}

      {directory.length > 0 && (
        <div className="pt-6">
          <div className="flex items-center gap-2 mb-3 text-white/40">
            <LayoutGrid className="w-4 h-4" />
            <span className="text-xs font-bold uppercase tracking-[0.2em]">Directory · {directory.length} more</span>
          </div>
          <div className="space-y-3" data-testid="directory-list">
            {directory.map((e) => (
              <BidCard key={e.user_id} entry={e} currency={currency} onNudge={onNudge} showPhone={showPhone} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
